import React from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import LinkIcon from '@material-ui/icons/Link';
import ClearIcon from '@material-ui/icons/Clear';
import { Button, Dialog, Tooltip } from '@material-ui/core';
import axios from 'axios';
import { copyTextToClipboard } from '../../functions';
import { storeContext } from '../provider/Provider';

const useStyles = makeStyles(() => ({
  videoItem: {
    border: '1px solid #A6A6A6',
    overflow: 'hidden',
    borderRadius: 5,
    '& > img': {
      cursor: 'pointer',
    },
  },
  info: {
    padding: '0 10px 10px',
    '& > h3': {
      cursor: 'pointer',
    },
  },
  bottom: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    color: '#58595B',
  },
  dialog: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dialogInner: {
    width: 1180,
    maxWidth: '90vw',
    padding: 40,
    position: 'relative',
    background: '#000',
    overflowX: 'hidden',
  },
  noButtonStyles: {
    padding: 'inherit',
    color: 'inherit',
    border: 'inherit',
    fontSize: 'inherit',
    fontFamily: 'inherit',
    fontWeight: 'inherit',
    background: 'inherit',
    cursor: 'pointer',
    '&:hover': {
      background: 'none',
    },
  },
  buttons: {
    '& > svg': {
      marginLeft: 6,
      cursor: 'pointer',
      color: '#58595B',
    },
    '& > .MuiTooltip-popper': {
      '& > .MuiTooltip-tooltip': {
        fontSize: 16,
        backgroundColor: '#00B5E2',
        '& > .MuiTooltip-arrow': {
          color: '#00B5E2',
        },
      },
    },
  },
}));

const { REACT_APP_FLASK_API_URL } = process.env;

const VideoItem = (props = { params: {}, updateCallback: () => {} }) => {
  const classes = useStyles();
  const { state } = React.useContext(storeContext);
  const history = useHistory();
  const { params = {}, updateCallback } = props;

  const [tooltipOpen, setTooltipOpen] = React.useState(false);
  const [isStared, setIsStarred] = React.useState(params.star);

  const handleTooltipClose = () => {
    setTooltipOpen(false);
  };

  const truncate = (string, limit = 280) =>
    string.length > limit ? `${string.substr(0, limit)}...` : string;

  const handleFavorite = async () => {
    const currentStar = !isStared;
    setIsStarred(currentStar);
    updateCallback({
      ...params,
      star: currentStar,
    });
    return axios.post(
      `${REACT_APP_FLASK_API_URL}/v1/loom/star/${state.websiteSwitch.currentWebsite}`,
      {
        message_ids: [params.message_id],
      }
    );
  };

  const handleCopy = () => {
    setTooltipOpen(true);
    setTimeout(() => {
      setTooltipOpen(false);
    }, 900);
    copyTextToClipboard(`${window.location.origin}/campaign-updates/open/${params.message_id}`);
  };

  return (
    <div className={classes.videoItem}>
      {params.thumbnail ? (
        <Button
          className={classes.noButtonStyles}
          onClick={() => {
            history.push(`/campaign-updates/open/${params.message_id}`);
          }}
        >
          <img src={params.thumbnail} alt={params.title} style={{ maxWidth: '100%' }} />
        </Button>
      ) : (
        ''
      )}
      <div className={classes.info}>
        <h3>
          <Button
            className={classes.noButtonStyles}
            onClick={() => {
              history.push(`/campaign-updates/open/${params.message_id}`);
            }}
          >
            {params.title}
          </Button>
        </h3>
        <p>{truncate(params.message)}</p>
        <div className={classes.bottom}>
          <div className="date">
            {moment.tz(params.date_created, 'America/Los_Angeles').fromNow()}
          </div>
          <div className={classes.buttons}>
            {isStared ? (
              <StarIcon style={{ color: '#00B5E2' }} onClick={handleFavorite} />
            ) : (
              <StarBorderIcon onClick={handleFavorite} />
            )}
            <Tooltip
              PopperProps={{
                disablePortal: true,
              }}
              onClose={handleTooltipClose}
              open={tooltipOpen}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title="Link Copied"
              placement="top"
              leaveDelay={200}
              arrow
            >
              <LinkIcon onClick={handleCopy} />
            </Tooltip>
          </div>
        </div>
      </div>
      <Dialog
        maxWidth="lg"
        className={classes.dialog}
        onClose={() => {
          history.push('/campaign-updates/');
        }}
        aria-labelledby="simple-dialog-title"
        open={params.open}
      >
        <div className={classes.dialogInner}>
          <div style={{ position: 'relative', paddingBottom: '62.5%', height: 0 }}>
            <iframe
              title={params.message_id}
              src={`https://www.loom.com/embed/${params.embedId}/?autoplay=1&hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true`}
              frameBorder="0"
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
            />
          </div>
          <Button
            style={{ position: 'absolute', top: -5, right: -12 }}
            onClick={() => {
              history.push('/campaign-updates/');
            }}
          >
            <ClearIcon style={{ color: '#fff', fontSize: 40, fontWeight: 'bold' }} />
          </Button>
        </div>
      </Dialog>
    </div>
  );
};

VideoItem.propTypes = {
  params: PropTypes.shape({}),
  updateCallback: PropTypes.func,
};

VideoItem.defaultProps = {
  params: PropTypes.shape({}),
  updateCallback: () => {},
};

export default VideoItem;
